import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class ParallaxEffectHero {
	constructor() {

		const containerEl = document.querySelector('[data-scroll-container]');

		const containerImage = document.querySelector('[data-scroll-image]');
		const containerVideo = document.querySelector('[data-scroll-video]');

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: containerEl,
				start: "top top",
				end: "bottom",
				scrub: 1,
			}
		});

		if(containerImage) {
			tl.to(containerImage, { yPercent: 20 });
		}

		if(containerVideo) {
			tl.to(containerVideo, { yPercent: 20 });
		}
	}
}
